var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdgyMountains01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{clip-path:url(#a);}.c{fill:#27ade3;}.d{fill:#75ab27;}.e{fill:#568b12;}.f{fill:#416e06;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 48,
    height: 48,
    rx: 12
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "edgyMountains") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: -9,
    y: -4,
    width: 65,
    height: 30
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "51 8.8 53 58 -5 56 0 21.9 22 11.8 40 21.9 51 8.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "e",
    points: "33 41 23 23 6 13 -6 35 -10 65 37 68 33 41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "f",
    points: "38 24 17 71 73 59 38 24"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdgyMountains01);
export default __webpack_public_path__ + "static/media/edgyMountains-01.b4a0d0ecef6ae94e80c94bd8b86a0aa7.svg";
export { ForwardRef as ReactComponent };